/**
 * HomeSurface — what `/` resolves to.
 *
 * `settings.uiMode === 'detailed'` keeps the full navigational shell (so the
 * detailed dashboard stays the landing for operators who chose it); everyone
 * else lands in the simplified rail + conversation surface.
 */
import React from 'react';
import { DetailedShell } from '../../components/DetailedShell.js';
import { useUiMode } from '../../hooks/useUiMode.js';
import { SimpleLandingPage } from './SimpleLandingPage.js';

export const HomeSurface: React.FC = () => {
  const { uiMode } = useUiMode();
  return uiMode === 'detailed' ? <DetailedShell /> : <SimpleLandingPage />;
};
